import { MeetingsApi } from "api";

export const fetchCalendarStatus = () => MeetingsApi.get('/scheduling/settings/status').then(resp => resp.data)